import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <footer className="border-t border-white/10 py-12 px-4 bg-[#0d1321]">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-start gap-8">
        <div className="max-w-sm">
          <div className="flex items-center gap-2 mb-4">
            <svg className="w-7 h-7 text-cyan-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
            <span
              className="text-xl font-bold text-white"
              style={{ fontFamily: "'Orbitron', sans-serif" }}
            >
              ScamView
            </span>
          </div>
          <p className="text-gray-500 text-sm leading-relaxed mb-4">
            ScamView helps identify potential scams in recruitment emails but does not guarantee accuracy.
            Always use personal judgment and verify independently.
          </p>
          <p className="text-gray-600 text-xs">
            &copy; 2026 ScamView. All rights reserved.
          </p>
        </div>

        <div className="flex gap-12">
          <div>
            <h4 className="font-bold text-white mb-4 text-sm">Product</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/login" className="hover:text-white transition">Login</Link></li>
              <li><Link to="/plans" className="hover:text-white transition">Sign Up</Link></li>
              <li><Link to="/plans" className="hover:text-white transition">Pricing</Link></li>
              <li><Link to="/how-to" className="hover:text-white transition">How To Use</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-white mb-4 text-sm">Company</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/about" className="hover:text-white transition">About</Link></li>
              <li><Link to="/faq" className="hover:text-white transition">FAQ</Link></li>
              <li><Link to="/security" className="hover:text-white transition">Security</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-white mb-4 text-sm">Legal</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><Link to="/privacy" className="hover:text-white transition">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-white transition">Terms of Service</Link></li>
              <li><Link to="/disclaimer" className="hover:text-white transition">Disclaimer</Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}
